import ExpertFeedbacksModerationMain from '../../components/admin/expert_feedbacks_moderation/main.vue'
import ExpertFeedbacksMain from '../../components/admin/expert_feedbacks/main.vue'

components = [
  { selector: "[data-vue-component='expert-feedbacks-moderation-main-vue']", component: ExpertFeedbacksModerationMain },
  { selector: "[data-vue-component='expert-feedbacks-main-vue']", component: ExpertFeedbacksMain }
]

window.Agiki.Common.VueComponentInitializer.registerComponents(components: components)
